import type { FaireProductEntity } from "../../entity_types/product";

export const p_sx89g4bfdd: FaireProductEntity = {
  token: "p_sx89g4bfdd",
  type: "product",
  name: "Andes Rug - 5x7",
  brandToken: "b_6jjy4txuzi",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/bc5577e60314700c99ce582172b96a15a8e5ca5f0e1d01b7cc1895d1ef93b71e.jpeg",
  galleryImageUrls: [],
  priceDollars: 144,
  description:
    "The woven Andes Rug features handcrafted jute embellishment and adds warmth and texture in easy to style neutral tones, making it the perfect grounding base layer for inspired interiors. Spot Clean Only.",
  tags: [],
  msrpDollars: 288,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:37.510Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
